
// import 'hooper/dist/hooper.css'
import Vue from 'vue'
const consola = require('consola'); consola.level = process.env.CONSOLA_LEVEL;
import { mapGetters, mapMutations, mapActions } from 'vuex'
import TextFx from '~/components/text-fx'
import svgSymbol from '~/components/svg-symbol'
import ctaArrow from '~/components/cta-arrow'
// import Carousel from '~/components/carousel'
import capitalize from '~/src/utils/capitalize'
import { setTimeout } from 'timers'

import HeaderMetaMixin from '~/mixins/header-meta'

import AnnouncementsMixin from '~/mixins/announcements'
import Intersect from '~/components/vue-intersect'
import ScrollObserver from '~/components/scroll-observer-raf'
import LazyHydrate from 'vue-lazy-hydration';
// import { Portal, PortalTarget } from 'portal-vue'
import last from '~/src/utils/last'
// import { lstat } from 'fs'

// this is how you can get the path of an image asset
// import pinSvg from '~/assets/svg/pin.svg'

// import yamlData from '~/assets/test.yaml'
const endsWith = require('lodash.endswith');

export default {

	layout: 'corporate',

	mixins: [HeaderMetaMixin, AnnouncementsMixin],

	components:
	{
		LazyHydrate,

		// you *MUST* declare components before you can use them
		// 'rest-img': RestImgDummy,// RestImg,
		// 'rest-prop': RestPropDummy, // RestProp,
		// 'rest-rich-text': RestRichTextDummy,// RestRichText,
		// 'rest-model': domel,// RestModel,
		// 'rest-link': RestPropLinkDummy, // 'rest-link': RestPropLink,
		// 'rest-string': RestStringDummy, // RestString,
		// 'rest-string-link': RestStringLinkDummy,// RestStringLink,
		// 'rest-date': RestDateDummy, // RestDate,
		// 'rest-date-add': domel,// RestDateAdd,
		// 'rest-reorder-list': RestReorderListDummy,//RestReorderList,
		// 'rest-list-item-add': domel,// RestListItemAdd,
		// 'rest-item-add': domel,// RestItemAdd,
		// 'rest-item-removable': domel,// RestItemRemovable,
		// 'tag-input': domel,// TagInput,

		// Portal,
		// PortalTarget,

		Intersect,
		ScrollObserver,

		// Affix,

		ctaArrow,
		svgSymbol,
		TextFx,
	},

	// this overrides the HeadMeatMixin
	// head: { bodyAttrs: { "class": ["page-generic"] } },

	data()
	{
		return {
			bodyClasses: ["page-generic"],

			pageLoaded: false,
			pageData: { block_list: [{}], },
			// blocks: [{}],

			currentSectionKey: 'key-benefits',

			resizeCallback: null,
			isEditingPage: false,
		};
	},


	// head()
	// {
	// 	return {
	// 		title: this.pageData ? this.pageData.title : '',
	// 		meta: [
	// 			{ hid: 'og:site_name', name: 'og:site_name', content: this.pageData ? this.pageData.title : '' },
	// 			{ hid: 'og:title', name: 'og:title', content: this.pageData ? this.pageData.title : '' },
	// 			{ hid: 'description', name: 'description', content: this.pageData ? this.pageData.description : '' },
	// 			{ hid: 'og:description', name: 'og:description', content: this.pageData ? this.pageData.description : '' },
	// 			{
	// 				// this.pageData.meta_pairs
	// 			// name: 'viewport',
	// 			// content: 'width=device-width,initial-scale=1.0,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no'
	// 			}
	// 		],
	// 	}
	// },


	async asyncData({app, params, store, error, req, route})
	{
		try {
			// consola.debug('route: ', route)
			// consola.debug('req: ', req)
			// debugger;
			// const lang = params.lang;
			const lang = params.lang || 'el';
			consola.debug('generic lang: ', lang)
			consola.debug('generic params: ', JSON.stringify(params) )
			// const result = await app.$apiGet('page-slug/'+params.slug, { locale: store.getters.lang } )
			store.dispatch('setLang', { lang: lang });
			store.dispatch('setDeviceWidthFromUserAgent');

			// if (params.generic == "null")
			// 	return {};

			const slug = '/page/' + (params.slug ? params.slug : '');

			let result = null;
			try{
				result = await app.$apiGet('page-slug/', { slug, locale: lang } )
			}
			catch (err)
			{
				consola.debug('error: "page-slug/'+slug +'" : ', err)
				return error({ statusCode: err.response.status, message: err.message })
				// if (error.response.status === 404)
				// {
				// }
				// return {
				// };
			}
			// const result = await app.$apiLoadCourseData('masterclass-in-translation')



			// consola.debug('typeof result: ', typeof result);
			consola.debug('Object.keys(result): ', Object.keys(result) );
			consola.debug('result.status: ', result.status );
			consola.debug('result.statusText: ', result.statusText );
			consola.debug('params.slug: ', slug);
			// consola.debug('result: ', result);

			const pageData = result.data[0];
			if (pageData.locale)
			{
				consola.debug('page locale: ', pageData.locale )
				store.commit('set_lang', { lang: pageData.locale })
			}

			if (pageData.course)
				for (let item of pageData.course.dates)
					item.delete = false;

			// if (result.status != 200)
			// {
			// 	// this does *NOT* work. it still tries to render the page template
			// 	error({ statusCode: result.status, message: result.statusText })
			// 	redirect(result.statusCode, '/')
			// 	// return ;
			// }
			// else

				const menu = pageData.menu && pageData.menu.json || [];
				store.commit('setPageMenu', menu);

				const footer = pageData.footer && pageData.footer.json || [];
				store.commit('setPageFooter', footer);

				consola.debug('taxonomies: ', pageData.taxonomies)
				consola.debug('blocklist count: ', pageData.block_list.length)
				// consola.debug('asyncData blocks[10].extra_data: ', result.data[0].block_list[10].extra_data)
				return {
					pageData,
					// blocks: result.data[0].block_list,
				}
		}
		catch (e)
		{
			consola.debug(`${__filename}[124] error: `, e)
			// error({ statusCode: 404, message: 'Page not found' })
			// error({ statusCode: 404, message: e })
		}
	},

	watch:
	{
		lang(newVal, prevVal)
		{
			consola.debug('language was changed, retrieving new data...')
		},


		// windowWidth(newVal, prevVal)
		// {
		// 	consola.debug('windowWidth: ', newVal);
		// 	// if (prevVal < 1030 && newVal > prevVal )
		// 	// {
		// 	// 	debugger;
		// 	// }
		// }
	},

	computed:
	{
		...mapGetters([ /*'isEditingPage'*/, 'getString', 'lang', 'langShort', 'allLanguages', 'windowWidth', 'isMobile', 'isTablet', 'isTabletOrBigger', 'isLargerThanTabletLandscape', 'isLaptop', 'isLaptopOrBigger', 'isDesktop', 'windowWidth', 'scrollTop']),

		blocks()
		{
			return this.pageData.block_list;
		},

	},

// this is called when the children have been mounted and the component is ready
	mounted()
	{
		// debugger;
		consola.debug('blocks: ', this.blocks)
		// this.$apiLoadCourseData('masterclass-in-translation').then((result)=>
		// {
		// 	consola.debug('result: ', result);
		// })
		// .catch((error)=>
		// {
		// 	console.error(error);
		// })

		this.$store.dispatch('setDeviceWidthFromWindow');

		this.isEditingPage = endsWith(this.$vnode.key, 'edit');

		this.$store.commit('setEditingPage', { editing: this.isEditingPage })


		this.registerEvents()

		if (this.pageData.announcements && this.pageData.announcements.length > 0)
		{
			for (let i = 0; i < this.pageData.announcements.length; i++)
			{
				let block = this.pageData.announcements[i];
				if (block.block_type == "announcement_head")
				{
					// consola.debug('emiting showTopBanner: ', block);
					// debugger;
					this.setTopBanner(block)
					// this.$nextTick( () => this.$root.$emit('showTopBanner', block) )
					break;
				}
			}
		}

		// consola.debug('partnersCategories: ', JSON.stringify( this.partnersCategories ) )

		// consola.debug('blocks[10].extra_data: ', this.blocks[10].extra_data)
		consola.debug('page_data: ', this.pageData)
		// consola.debug('$parent', this.$parent)

		// consola.debug('generic lang: ', this.$store.getters.lang)

		this.$nextTick( ()=>
		{
			setTimeout( ()=>
			{
				this.pageLoaded = true;
			}, 10 )
		} )
	},

	beforeDestroy()
	{
		this.unregisterEvents()
	},

	methods:
	{
		...mapMutations( ['setTopBanner',] ),



		log(msg)
		{
			consola.debug(msg)
		},

		registerEvents()
		{
			if ( typeof window !== 'undefined' )
			{
				this.resizeCallback = () => this.onWindowResize()
				window.addEventListener('resize', this.resizeCallback )
			}
			this.$eventBus.$on( 'rest:response', this.updateData )
			this.$eventBus.$on( 'set-page-data', this.setPageData )
		},

		unregisterEvents()
		{
			if ( typeof window !== 'undefined' )
			{
				if (this.resizeCallback)
					window.removeEventListener('resize', this.resizeCallback )
			}
			this.$eventBus.$off( 'rest:response', this.updateData )
			this.$eventBus.$off( 'set-page-data', this.setPageData )
		},


		updateData(modelResponse)
		{
			this.fetchData()
		},

		setPageData(data)
		{
			consola.debug('setPageData')

			let scrollY = 0;
			if (typeof window !=='undefined')
				scrollY = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;


			this.pageData = data;
			let menu = this.pageData.menu && this.pageData.menu.json || [];
			this.$store.commit('setPageMenu', menu);

			const footer = this.pageData.footer && this.pageData.footer.json || [];
			this.$store.commit('setPageFooter', footer);
			// this.blocks = this.pageData.block_list;

			if (typeof window !=='undefined')
			{
				setTimeout( ()=>
				{
					if (document.documentElement.scrollTop)	document.documentElement.scrollTop = scrollY;
					if (window.pageYOffset)					window.pageYOffset = scrollY;
					if (document.body.scrollTop)			document.body.scrollTop = scrollY;
				}, 0);
			}
		},

		onWindowResize()
		{
		},


		async fetchData()
		{
			// get the last path element
			// let slug = window.location.pathname.split('/').reduce( (_, x) => x )

			let slug = window.location.pathname.replace('/edit', '').split('/');
			if ( last(slug) == 'edit' )	slug.pop();
			slug = last( slug );

			this.$apiGet('page-slug/', { slug,  locale: this.lang } )
				.then( (result) =>
				{
					consola.debug('Object.keys(result): ', Object.keys(result) );
					consola.debug('result.status: ', result.status );
					consola.debug('result.statusText: ', result.statusText );
					// consola.debug('result: ', result);

					this.pageData = result.data[0]
					// this.blocks = result.data[0].block_list
					consola.debug('pageData: ', result.data[0])

				})
				.catch( (error) =>
				{
					console.error('generic fetchData error: ', error)
				} )
		},

		capitalize(str)
		{
			return capitalize(str);
		},

		onIntersection(event)
		{
			consola.debug('onIntersection: ', event);
		},

		// onScrollerTick()
		// {
		// 	// consola.debug('tick');

	}
}
